// extracted by mini-css-extract-plugin
module.exports = {"flashy":"Flashy-module--flashy--3NBm0","current":"Flashy-module--current--SYRLU","wrapper":"Flashy-module--wrapper--3rbI0"};